import React, { useId } from 'react';
import { t } from '@lingui/macro';

import Modal from '@rover/kibble/official-patterns/Modal';
import { SM_MIN } from '@rover/kibble/styles/MediaQuery';
import useMatchMedia from '@rover/react-lib/src/hooks/useMatchMedia';

import { useSearchByNameExperiment } from './hooks/useSearchByNameExperiment';
import SearchByNameContent from './SearchByNameContent';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  initialLocation?: string;
};

const SearchByNameOverlay = ({ isOpen, onClose, initialLocation }: Props): JSX.Element | null => {
  const { isEnabled } = useSearchByNameExperiment();
  const isMobile = !useMatchMedia(`(min-width:${SM_MIN}px)`);
  const headerId = useId();
  const headerText = t`Search by name`;

  if (!isEnabled || isMobile) return null;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      headerText={headerText}
      headerSize="400"
      showCloseIcon
      headerId={headerId}
      contentProps={{ width: '600px', maxHeight: '80vh', sx: { overflowY: 'auto' } }}
    >
      {isOpen && <SearchByNameContent initialLocation={initialLocation} />}
    </Modal>
  );
};

export default SearchByNameOverlay;
